/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const VERIFY_IMAGE_DETECTIONS = gql`
  mutation VerifyImageDetections($imageId: ID!) {
    verifyImageDetections(imageId: $imageId) {
      __typename
      ... on VerifyImageDetectionsResult {
        imageId
        success
      }
      ... on OperationInfo {
        messages {
          kind
          message
          field
          code
        }
      }
    }
  }
`
